var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSuccessfulDepositsCount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 2.526C12.002 3.718 9.43498 5.05096 6.00198 5.05096C2.57398 5.05096 0.00198364 3.713 0.00198364 2.526C0.00198364 1.339 2.57298 0 6.00198 0C9.43098 0 12.002 1.334 12.002 2.526Z",
    fill: "#8D939C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.444 15.077C6.96525 15.1311 6.48378 15.1578 6.00198 15.157C2.57398 15.157 0.00299072 13.824 0.00299072 12.623V11.951C0.25022 12.1156 0.508126 12.2636 0.774994 12.394C2.41443 13.1366 4.19846 13.5055 5.99799 13.474C6.08362 13.474 6.16799 13.4717 6.25172 13.4694C6.33422 13.4672 6.4161 13.465 6.49799 13.465C6.73645 14.0439 7.0549 14.5865 7.444 15.077Z",
    fill: "#8D939C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05399 11.79H6.00198V11.794C2.56898 11.794 0.0039978 10.456 0.0039978 9.26398V8.59296C0.251664 8.75537 0.509534 8.90173 0.776001 9.03101C2.41678 9.7724 4.20178 10.1399 6.00198 10.107H6.05399C5.983 10.6657 5.983 11.2312 6.05399 11.79Z",
    fill: "#8D939C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50198 8.41296C6.34098 8.42396 6.17298 8.42401 6.00198 8.42401C2.56898 8.42401 0.004 7.09401 0 5.89801V5.22595C0.247649 5.38869 0.505519 5.53536 0.772003 5.66498C2.41329 6.40567 4.19862 6.77248 5.99899 6.73895C6.52545 6.73901 7.05155 6.71099 7.57501 6.65497C7.12901 7.18226 6.76705 7.77524 6.50198 8.41296Z",
    fill: "#8D939C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72275 10.6863C7.77034 9.78134 8.06474 8.9066 8.57401 8.15698C9.05619 7.44516 9.70999 6.86635 10.475 6.474C11.6807 5.8507 13.0827 5.72483 14.3802 6.12341C15.6776 6.522 16.7672 7.41324 17.415 8.60596C17.7273 9.19455 17.9189 9.83961 17.9787 10.5032C18.0385 11.1669 17.9651 11.8357 17.763 12.4706C17.5609 13.1056 17.2341 13.6937 16.8017 14.2007C16.3693 14.7076 15.8401 15.1232 15.245 15.423C14.0391 16.0461 12.637 16.1718 11.3395 15.7733C10.0419 15.3747 8.9522 14.4836 8.30399 13.291C7.87616 12.492 7.67515 11.5913 7.72275 10.6863ZM13.7196 13.9681V8.60425L11.5326 8.81055V9.75706H12.5886V13.9681H13.7196Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSuccessfulDepositsCount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_successful_deposits_count.b490a9dd8c5818a524ae0d326c52583a.svg";